import { useCallback, useState } from 'react';

/**
 * Open/close state for the "What should your model do next?" modal. Hosts
 * (Business Goals step, Edit Task modal) pass `openModal` down as the
 * `onContactUs` handler of the gated task-type / autonomy controls.
 */
export default function useCustomerIntentModal() {
    const [open, setOpen] = useState(false);
    const openModal = useCallback(() => setOpen(true), []);
    const closeModal = useCallback(() => setOpen(false), []);
    return { open, openModal, closeModal };
}
